/**
 * @generated SignedSource<<3abd57aac6be0ed211aed0d1701f4946>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusArticleDateContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksArticleDateUtilsContent">;
  readonly " $fragmentType": "plusArticleDateContent";
};
export type plusArticleDateContent$key = {
  readonly " $data"?: plusArticleDateContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusArticleDateContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusArticleDateContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksArticleDateUtilsContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "06650c68ab5eb60ad7971d1dcf0fd11b";

export default node;
